import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { BatchesOverviewContainerComponent } from './containers/batches-overview-container/batches-overview-container.component';


const routes: Routes = [
    {
        path: '',
        component: BatchesOverviewContainerComponent
    }
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class BatchesRoutingModule {}
